export const Junagadh = {
    title: "Junagadh",
    title1: "(Historic City)",

    attractions: [
        {
            name: "Girnar Hill",
            description: "Girnar Hill is one of the most sacred pilgrimage sites in Gujarat, known for its cluster of Jain and Hindu temples. The hill offers a challenging trek with over 10,000 steps leading to the summit, where visitors are rewarded with breathtaking views and spiritual serenity. It is also a popular spot for nature lovers and adventure enthusiasts.",
            location: "Junagadh, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Trek to the summit",
                "Visit Jain and Hindu temples",
                "Enjoy panoramic views of the surrounding landscape",
                "Attend the annual Girnar Parikrama festival",
                "Explore the lush greenery and wildlife"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1A",
        },
        {
            name: "Uparkot Fort",
            description: "Uparkot Fort is an ancient fort with a history dating back over 2,300 years. It features impressive structures like the Jama Masjid, Buddhist caves, and step wells. The fort offers a glimpse into the rich history and architectural brilliance of Junagadh.",
            location: "Junagadh, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "₹20 for Indians, ₹100 for foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the ancient fort walls",
                "Visit the Jama Masjid",
                "Discover the Buddhist caves",
                "Admire the step wells",
                "Learn about the fort's history"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1B",
        },
        {
            name: "Mahabat Maqbara",
            description: "Mahabat Maqbara is a stunning mausoleum known for its intricate Indo-Islamic architecture. It houses the tombs of Junagadh's rulers and is a fine example of the fusion of Gothic and Islamic styles.",
            location: "Junagadh, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Admire the architectural details",
                "Photograph the stunning structure",
                "Learn about the history of the Nawabs of Junagadh",
                "Explore the surrounding gardens"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1C",
        },
        {
            name: "Sakkarbaug Zoological Garden",
            description: "Sakkarbaug Zoo is one of the oldest zoos in India and is home to a variety of wildlife, including the Asiatic lion. It also houses a museum showcasing the region's natural history.",
            location: "Junagadh, Gujarat",
            timings: "9:00 AM to 6:30 PM",
            ticket: "₹50 for adults, ₹20 for children",
            bestTimeToVisit: "October to March",
            activities: [
                "Spot the Asiatic lion",
                "Visit the natural history museum",
                "Explore the diverse wildlife",
                "Enjoy a family outing"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1D",
        },
        {
            name: "Ashoka's Rock Edicts",
            description: "These ancient rock edicts date back to the 3rd century BCE and are inscribed with the teachings of Emperor Ashoka. They are a significant archaeological site and a testament to India's ancient history.",
            location: "Junagadh, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Read the ancient inscriptions",
                "Learn about Emperor Ashoka's teachings",
                "Photograph the historical site",
                "Explore the surrounding area"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1E",
        },
        {
            name: "Darbar Hall Museum",
            description: "Darbar Hall Museum is housed in the former palace of the Nawabs of Junagadh. It showcases a rich collection of artifacts, including weapons, costumes, and paintings, offering a glimpse into the royal lifestyle.",
            location: "Junagadh, Gujarat",
            timings: "10:00 AM to 6:00 PM",
            ticket: "₹20 for Indians, ₹100 for foreigners",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the royal artifacts",
                "Admire the paintings and costumes",
                "Learn about the Nawabs' history",
                "Photograph the palace architecture"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1F",
        },
        {
            name: "Damodar Kund",
            description: "Damodar Kund is a sacred water tank located at the base of Girnar Hill. It is believed to have religious significance and is a popular spot for pilgrims.",
            location: "Junagadh, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Take a dip in the holy water",
                "Attend religious ceremonies",
                "Enjoy the serene atmosphere",
                "Visit nearby temples"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1G",
        },
        {
            name: "Buddhist Caves",
            description: "The Buddhist Caves in Junagadh are a group of ancient rock-cut caves dating back to the 2nd century BCE. They are an important archaeological site and reflect the region's Buddhist heritage.",
            location: "Junagadh, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the rock-cut architecture",
                "Learn about Buddhist history",
                "Photograph the ancient carvings",
                "Enjoy the peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1H",
        },
        {
            name: "Narsinh Mehta Choro",
            description: "Narsinh Mehta Choro is a temple dedicated to the famous Gujarati poet-saint Narsinh Mehta. It is a place of spiritual significance and cultural importance.",
            location: "Junagadh, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Attend devotional songs and prayers",
                "Learn about Narsinh Mehta's life",
                "Explore the temple architecture",
                "Participate in cultural events"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1I",
        },
        {
            name: "Adi-Kadi Vav and Navghan Kuwo",
            description: "These ancient step wells are marvels of engineering and architecture. Adi-Kadi Vav and Navghan Kuwo are known for their intricate designs and historical significance.",
            location: "Junagadh, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Admire the step well architecture",
                "Learn about their historical importance",
                "Photograph the intricate designs",
                "Explore the surrounding area"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1J",
        },
        {
            name: "Willingdon Dam",
            description: "Willingdon Dam is a picturesque spot located near Junagadh. It is a popular destination for picnics and offers stunning views of the surrounding landscape.",
            location: "Junagadh, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Enjoy a picnic with family and friends",
                "Photograph the scenic views",
                "Relax by the water",
                "Explore the nearby areas"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1K",
        },
        {
            name: "Moti Baug",
            description: "Moti Baug is a beautiful garden located in Junagadh. It is a perfect spot for relaxation and offers a peaceful environment for visitors.",
            location: "Junagadh, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Stroll through the garden",
                "Enjoy the serene atmosphere",
                "Photograph the lush greenery",
                "Relax and unwind"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1L",
        },
        {
            name: "Bhavnath Mahadev Temple",
            description: "Bhavnath Mahadev Temple is an ancient temple dedicated to Lord Shiva. It is located at the base of Girnar Hill and is a significant pilgrimage site.",
            location: "Junagadh, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Attend the Maha Shivaratri festival",
                "Offer prayers at the temple",
                "Explore the surrounding area",
                "Enjoy the spiritual atmosphere"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1M",
        },
        {
            name: "Sonapur Beach",
            description: "Sonapur Beach is a serene and less-crowded beach located near Junagadh. It is a perfect spot for relaxation and enjoying the natural beauty of the Arabian Sea.",
            location: "Near Junagadh, Gujarat",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Relax on the beach",
                "Enjoy the sunset",
                "Take a walk along the shore",
                "Photograph the scenic views"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1N",
        },
        {
            name: "Gir National Park",
            description: "Gir National Park is the only place in the world where you can spot the Asiatic lion in the wild. It is a must-visit for wildlife enthusiasts and nature lovers.",
            location: "Near Junagadh, Gujarat",
            timings: "6:00 AM to 5:00 PM",
            ticket: "₹800 for Indians, ₹4,000 for foreigners",
            bestTimeToVisit: "December to March",
            activities: [
                "Go on a safari to spot lions",
                "Explore the diverse wildlife",
                "Photograph the natural beauty",
                "Learn about conservation efforts"
            ],
            mapLink: "https://maps.app.goo.gl/7z8X9yZ1Q1Z1Q1Z1O",
        },
    ]
};